import { DimensionInfo } from "./DimensionInfo";

/**
 * 运行时定制信息
 */
export class CustomizationInfo {
    /**
     * 是否是运行时定制
     */
    Customized: boolean;

    /**
     * 维度信息
     */
    DimensionInfo: DimensionInfo;
  
}
